import React from 'react'
import Skeleton from 'react-loading-skeleton'

import styles from './styles.module.css'

const SingleOrderSkeleton = () => {
  return (
    <div className={styles.container}>
      <div className={styles.map_skeleton}>
        <Skeleton width={'100%'} height={167} />
      </div>
      <div style={{ marginBottom: 16 }}>
        <Skeleton width={'100%'} height={34} />
      </div>
      <div className="d-flex justify-content-between align-items-center">
        <Skeleton width={63} height={17} />
        <Skeleton width={63} height={17} />
      </div>
      <div style={{ marginTop: 32 }}>
        <div style={{ marginBottom: 16 }}>
          <Skeleton width={60} height={23} />
        </div>
        <div style={{ marginBottom: 12 }}>
          <Skeleton width={'100%'} height={68} />
        </div>
        <div style={{ marginBottom: 12 }}>
          <Skeleton width={'100%'} height={68} />
        </div>
        <div style={{ marginBottom: 12 }}>
          <Skeleton width={'100%'} height={68} />
        </div>
      </div>
    </div>
  )
}

export default SingleOrderSkeleton
